import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=6c227ff3&scoped=true&"
import script from "./CardImage.vue?vue&type=script&lang=js&"
export * from "./CardImage.vue?vue&type=script&lang=js&"
import style0 from "./CardImage.vue?vue&type=style&index=0&id=6c227ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c227ff3",
  null
  
)

export default component.exports